module.exports = __webpack_public_path__ + "743fd5a042de95f5531bb959dcd93f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-320.jpg
// module id = 617
// module chunks = 0